/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Hero_BadgeInputs */

const en_landing_hero_badge = /** @type {(inputs: Landing_Hero_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-native infrastructure for Sell-Side research`)
};

/**
* | output |
* | --- |
* | "AI-native infrastructure for Sell-Side research" |
*
* @param {Landing_Hero_BadgeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_hero_badge = /** @type {((inputs?: Landing_Hero_BadgeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Hero_BadgeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_hero_badge(inputs)
});